import { AccountPageLayout } from "./AccountPageLayout";
import { Spinner } from "@components/Spinner";
import styles from "./styles/Account.module.css";

export const Loading = ({ title }) => {
  return (
    <AccountPageLayout title={title}>
      <div className={styles.spinner}>
        <Spinner />
      </div>
    </AccountPageLayout>
  )
}